import React from 'react';
import { useTranslation } from 'react-i18next';
import { TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { cn } from '@/lib/utils';
import {
  classificationKeys,
  getLocalizedClassificationLabel,
  getLocalizedMethodLabel,
  methodKeys,
} from '@utils/verificationLabels';
import {
  classHeaderCell,
  headerCell,
  methodHeaderCell,
  stickyCol0,
  stickyCol1,
  stickyHeaderCorner,
  verticalHeaderCell,
  verticalHeaderText,
} from './itemTableLayout';

const VerificationItemTableHeader: React.FC = () => {
  const { t } = useTranslation();

  return (
    <TableHeader>
      <TableRow className="hover:bg-transparent">
        <TableHead rowSpan={2} className={cn(headerCell, stickyCol0, stickyHeaderCorner)}>
          No
        </TableHead>
        <TableHead rowSpan={2} className={cn(headerCell, stickyCol1, stickyHeaderCorner)}>
          {t('verification.table.unit')}
        </TableHead>
        <TableHead rowSpan={2} className={cn(headerCell, 'revy-cjk min-w-[100px]')}>
          {t('verification.table.specification')}
        </TableHead>
        <TableHead rowSpan={2} className={cn(headerCell, 'revy-cjk min-w-[120px]')}>
          {t('verification.table.itemName')}
        </TableHead>
        <TableHead
          colSpan={classificationKeys.length}
          className={cn(classHeaderCell, 'revy-cjk text-center')}
        >
          {t('verification.table.classification')}
        </TableHead>
        <TableHead rowSpan={2} className={cn(headerCell, 'revy-cjk min-w-[160px]')}>
          {t('verification.table.standardTarget')}
        </TableHead>
        <TableHead
          colSpan={methodKeys.length}
          className={cn(methodHeaderCell, 'revy-cjk text-center')}
        >
          {t('verification.table.verificationMethod')}
        </TableHead>
        <TableHead rowSpan={2} className={cn(headerCell, 'revy-cjk min-w-[40px] text-center')}>
          {t('verification.table.review')}
        </TableHead>
        <TableHead rowSpan={2} className={cn(headerCell, 'w-[36px] min-w-[36px]')}>
          &nbsp;
        </TableHead>
      </TableRow>
      <TableRow className="hover:bg-transparent">
        {classificationKeys.map((key) => (
          <TableHead key={key} className={cn(classHeaderCell, verticalHeaderCell)}>
            <div className={verticalHeaderText}>{getLocalizedClassificationLabel(t, key)}</div>
          </TableHead>
        ))}
        {methodKeys.map((key) => (
          <TableHead key={key} className={cn(methodHeaderCell, verticalHeaderCell)}>
            <div className={verticalHeaderText}>{getLocalizedMethodLabel(t, key)}</div>
          </TableHead>
        ))}
      </TableRow>
    </TableHeader>
  );
};

export default VerificationItemTableHeader;
